import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  FormsModule as AngularFormsModule,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { WidthdrawalComponent } from "./widthdrawal/widthdrawal.component";
import { ConfirmDialogModule } from "primeng/primeng";
import { BsDatepickerModule } from "ngx-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ImageService } from "../../../imageService";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ConfirmDialogModule,
    BsDatepickerModule.forRoot(),
    TranslateModule
  ],
  declarations: [WidthdrawalComponent]
})
export class WidthdrawalModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/widthdrawal/widthdrawal.module.ts